import { render } from "./BulkDemandNoticeModal.vue?vue&type=template&id=19b32665&scoped=true"
import script from "./BulkDemandNoticeModal.vue?vue&type=script&lang=js"
export * from "./BulkDemandNoticeModal.vue?vue&type=script&lang=js"

import "./BulkDemandNoticeModal.vue?vue&type=style&index=0&id=19b32665&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b32665"]])

export default __exports__